// src/utils/ability.js
import { createMongoAbility } from "@casl/ability";
import { unpackRules } from "@casl/ability/extra";

let ability = createMongoAbility([]); // start empty

export function getAbility() {
	return ability;
}

export function setAbilityFromPacked(packedRules) {
	// packedRules should be the array you got from /auth/me -> ability.rules
	ability = createMongoAbility(unpackRules(packedRules || []));
}

// optional helper if you want to clear it on logout
export function resetAbility() {
	ability = createMongoAbility([]);
}

// (optional) expose for quick debugging in the browser console
if (typeof window !== "undefined") {
	window.__getAbility = getAbility;
}
